import { Tenants } from "config/security";
import { stringHelpers } from "infrastructure/helpers";

export const isPlexTenant = (tenantId: string) => {
  return stringHelpers.equal(tenantId, Tenants.Plex);
};
